import { Filter } from 'app/modules/filters/models';
import { FintracFilingStatus } from 'app/modules/fintracStr/enums';
import { ListFintracStrFilingsRequest } from 'app/modules/fintracStr/requests';
import { FINTRAC_STR_DATE_FORMAT } from 'app/modules/fintracStr/formConstants';
import { parse, isValid } from 'date-fns';

export const parseFintracDate = (date?: string): Date | undefined => {
  if (!date) {
    return undefined;
  }

  const parsed = parse(date, FINTRAC_STR_DATE_FORMAT, new Date(0));

  if (isValid(parsed)) {
    return parsed;
  }

  return undefined;
};

export const isFintracFilingSubmitted = (
  fintracFilingStatus: FintracFilingStatus,
): boolean => {
  return [
    FintracFilingStatus.SUBMITTED_WITH_WARNINGS,
    FintracFilingStatus.SUBMITTED_WITH_SUCCESS,
  ].includes(fintracFilingStatus);
};

export const createFintracStrFilterPayload = (
  filters: Filter[],
): Pick<ListFintracStrFilingsRequest, 'filters'> => {
  // laying groundwork for adding more filters
  return {
    filters: filters.reduce((acc: Filter[], i) => {
      acc.push(i);
      return acc;
    }, []),
  };
};
